import { create } from 'zustand'

export const useSttStore = create<{
  isFocusInsertable: boolean
  setIsFocusInsertable: (value: boolean) => void
}>()(set => ({
  isFocusInsertable: false,
  setIsFocusInsertable: value => set({ isFocusInsertable: value })
}))
